import { JSX, useEffect, useState } from 'react';

type Props = {
  display?: boolean;
  children: JSX.Element | JSX.Element[];
  /** delays rendering children in ms. Useful, for example, to show things like waiting indicators after a specific amount of time */
  delayRender?: number;
  /** displayTimeLimit is the time in ms that the component will be displayed. If the time limit is reached, the component will be hidden. 0/undefined will be infinite */
  displayTimeLimit?: number;
};

function OptionalComponent({ display, children, delayRender = 0, displayTimeLimit }: Props): JSX.Element | null {
  const [shouldRender, setShouldRender] = useState(delayRender <= 0);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (display && delayRender > 0) {
      timeoutId = setTimeout(() => {
        setShouldRender(true);
      }, delayRender);
    } else {
      setShouldRender(!!display);
    }

    return () => clearTimeout(timeoutId);
  }, [display, delayRender]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (shouldRender && displayTimeLimit) {
      timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, displayTimeLimit);
    }

    return () => clearTimeout(timeoutId);
  }, [shouldRender, displayTimeLimit]);

  if (display && shouldRender) {
    return <>{children}</>;
  }

  return null;
}

export default OptionalComponent;
